module.exports = __webpack_public_path__ + "img/spinner-200px.86dd86aa.gif";